export const COMPONENT_NAME = 'MegaNav';